module.exports = __webpack_public_path__ + "static/img/devoffline.647cce2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/devoffline.png
// module id = ex+z
// module chunks = 2